<template>
  <span class="base-dot-icon inline-block w-2 h-2 rounded-full bg-current"></span>
</template>

<script>
export default {
  name: 'base-dot-icon'
}
</script>
<style>
.bg-current {
    background-color: currentColor;
}
</style>
